import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { ShoppingCart, Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import img1 from '../components/images/retail_weighing/retail_banner.png'
import img2 from '../components/images/retail_weighing/3.png'
import img3 from '../components/images/retail_weighing/R2.jpg'
import img4 from '../components/images/retail_weighing/ai.png'

export default function RetailWeighingScale() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const categories = [
    {
      id: 1,
      name: 'Ai Weighing scales',
      image: img4,
      description: 'Smart. Fast. Accurate. The next generation of weighing — powered by AI.',
      items: '4+ Products'
    },
    {
      id: 2,
      name: 'Dibal Weighing Scales',
      image: img2,
      description: 'European precision and reliability — trusted across global retail industries.Trendy clothing and accessories',
      items: '10+ Products'
    },
    {
      id: 3,
      name: 'Rongta Weighing Scales',
      image: img3,
      description: 'Affordable innovation with dependable performance — perfect when cost matters.',
      items: '2+ Products'
    }
  ];

  const handleSubmit = () => {
    if (formData.name && formData.email && formData.message) {
      alert('Thank you for your message! We will get back to you soon.');
      setFormData({ name: '', email: '', message: '' });
    } else {
      alert('Please fill in all fields');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      {/* <header className="relative bg-gradient-to-br from-black via-gray-900 to-gray-800 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(252, 163, 17, 0.1) 35px, rgba(252, 163, 17, 0.1) 70px)'
          }}></div>
        </div>
        
        

        <div className="relative z-10 container mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h1 className="text-5xl md:text-6xl font-bold leading-tight">
              Discover Your
              <span className="block" style={{ color: '#FCA311' }}>Perfect Style</span>
            </h1>
            <p className="text-xl" style={{ color: '#E5E5E5' }}>
              Premium quality products curated just for you. Experience excellence in every purchase with our handpicked collection.
            </p>
            <div className="flex gap-4">
              <button className="px-8 py-4 rounded-full font-bold text-black hover:scale-105 transition-transform flex items-center gap-2" style={{ backgroundColor: '#FCA311' }}>
                Shop Now
                <ArrowRight size={20} />
              </button>
              <button className="px-8 py-4 rounded-full font-bold border-2 hover:bg-white hover:text-black transition-colors" style={{ borderColor: '#E5E5E5' }}>
                Learn More
              </button>
            </div>
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 rounded-3xl opacity-20 blur-3xl" style={{ backgroundColor: '#FCA311' }}></div>
            <img 
              src="https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=800&q=80" 
              alt="Featured Product" 
              className="relative z-10 rounded-3xl shadow-2xl w-full object-cover aspect-square"
            />
            <div className="absolute -bottom-6 -left-6 px-6 py-4 rounded-2xl shadow-xl z-20" style={{ backgroundColor: '#14213D' }}>
              <div className="text-sm" style={{ color: '#E5E5E5' }}>Starting from</div>
              <div className="text-3xl font-bold" style={{ color: '#FCA311' }}>$99.99</div>
            </div>
          </div>
        </div>
      </header> */}

      {/* Categories Section */}

      <section>
                        <div className="w-full h-full relative mt-5 font-poppins">
                            <img
                                src={img1}
                                alt="Banner"
                                className="w-full h-full object-cover"
                            />
                        </div>
                            
      </section>
      <section className="py-20" style={{ backgroundColor: '#E5E5E5' }}>
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: '#14213D' }}>
              Explore Our Categories
            </h2>
            <p className="text-xl" style={{ color: '#000000' }}>
              Wide variety of products across multiple categories
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.map((category) => (
              <div 
                key={category.id}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:scale-105 cursor-pointer group"
              >
                <div className="relative overflow-hidden h-64">
                  <img 
                    src={category.image} 
                    alt={category.name}
                    className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-60"></div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <div className="text-sm font-semibold" style={{ color: '#FCA311' }}>{category.items}</div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold mb-2" style={{ color: '#14213D' }}>
                    {category.name}
                  </h3>
                  <p className="text-gray-600 mb-4">{category.description}</p>
                  <button className="text-sm font-semibold flex items-center gap-2 hover:gap-3 transition-all" style={{ color: '#FCA311' }}>
                    Contact Us
                    <ArrowRight size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20" style={{ backgroundColor: '#14213D' }}>
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#FCA311' }}>
                Love Our Products?
              </h2>
              <p className="text-xl mb-8" style={{ color: '#E5E5E5' }}>
                Get in touch with us for any queries, custom orders, or just to say hello. We're here to help!
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-lg" style={{ backgroundColor: '#FCA311' }}>
                    <Phone size={24} style={{ color: '#14213D' }} />
                  </div>
                  <div>
                    <div className="font-semibold" style={{ color: '#FCA311' }}>Phone</div>
                    <div style={{ color: '#E5E5E5' }}>055 3500531</div>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-lg" style={{ backgroundColor: '#FCA311' }}>
                    <Mail size={24} style={{ color: '#14213D' }} />
                  </div>
                  <div>
                    <div className="font-semibold" style={{ color: '#FCA311' }}>Email</div>
                    <div style={{ color: '#E5E5E5' }}>sales@tsgce-sa.com</div>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-lg" style={{ backgroundColor: '#FCA311' }}>
                    <MapPin size={24} style={{ color: '#14213D' }} />
                  </div>
                  <div>
                    <div className="font-semibold" style={{ color: '#FCA311' }}>Address</div>
                    <div style={{ color: '#E5E5E5' }}>P.O Box 34426- Al khobar<br/>Kingdom of Saudi Arabia</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-2xl">
              <h3 className="text-2xl font-bold mb-6" style={{ color: '#14213D' }}>
                Send Us a Message
              </h3>
              <div className="space-y-4">
                <div>
                  <div className="block text-sm font-semibold mb-2" style={{ color: '#14213D' }}>
                    Your Name
                  </div>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    className="w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:border-opacity-100 transition-colors"
                    style={{ borderColor: '#E5E5E5' }}
                    placeholder="John Doe"
                  />
                </div>
                
                <div>
                  <div className="block text-sm font-semibold mb-2" style={{ color: '#14213D' }}>
                    Email Address
                  </div>
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:border-opacity-100 transition-colors"
                    style={{ borderColor: '#E5E5E5' }}
                    placeholder="john@example.com"
                  />
                </div>
                
                <div>
                  <div className="block text-sm font-semibold mb-2" style={{ color: '#14213D' }}>
                    Message
                  </div>
                  <textarea
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    rows="4"
                    className="w-full px-4 py-3 rounded-lg border-2 focus:outline-none focus:border-opacity-100 transition-colors resize-none"
                    style={{ borderColor: '#E5E5E5' }}
                    placeholder="Tell us about your inquiry..."
                  ></textarea>
                </div>
                
                <button
                  className="text-sm font-semibold flex items-center gap-2 hover:gap-3 transition-all"
                  style={{ color: "#FCA311" }}
                  onClick={() => navigate("/contactus")}
                >
                  Contact Us
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      
    </div>
  );
}